// @ts-nocheck
/* eslint-disable */
/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SUREnet producten-internal API
 * OpenAPI spec version: 1
 */
import { useMutation, useQuery } from '@tanstack/vue-query';
import type {
  DataTag,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType,
} from '@tanstack/vue-query';

import { computed, toValue, unref } from 'vue';
import type { MaybeRefOrGetter } from 'vue';

import type { CollectionResultOfProductenPakkettenPakketDto } from '../model/collectionResultOfProductenPakkettenPakketDto.ts';

import type { MicrosoftAspNetCoreHttpHttpValidationProblemDetails } from '../model/microsoftAspNetCoreHttpHttpValidationProblemDetails.ts';

import type { MicrosoftAspNetCoreMvcProblemDetails } from '../model/microsoftAspNetCoreMvcProblemDetails.ts';

import type { ProductenPakkettenPakketDto } from '../model/productenPakkettenPakketDto.ts';

import type { Result1OfProductenPakkettenPakketDto } from '../model/result1OfProductenPakkettenPakketDto.ts';

import { customInstance } from '../../customInstance.ts';
import type { ErrorType } from '../../customInstance.ts';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 *  <br /> Required permissions:<br /> <ul> <li>Permission: Inregeling.InregelingInzien</li></ul>
 * @summary Geeft een lijst van pakketten terug.
 */
export const pakkettenAll = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<CollectionResultOfProductenPakkettenPakketDto>(
    { url: `/api/v1/pakketten`, method: 'GET', signal },
    options,
  );
};

export const getPakkettenAllQueryKey = () => {
  return ['api', 'v1', 'pakketten'] as const;
};

export const getPakkettenAllQueryOptions = <
  TData = Awaited<ReturnType<typeof pakkettenAll>>,
  TError = ErrorType<void>,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof pakkettenAll>>, TError, TData>>;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getPakkettenAllQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof pakkettenAll>>> = ({ signal }) =>
    pakkettenAll(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof pakkettenAll>>,
    TError,
    TData
  >;
};

export type PakkettenAllQueryResult = NonNullable<Awaited<ReturnType<typeof pakkettenAll>>>;
export type PakkettenAllQueryError = ErrorType<void>;

/**
 * @summary Geeft een lijst van pakketten terug.
 */

export function usePakkettenAll<
  TData = Awaited<ReturnType<typeof pakkettenAll>>,
  TError = ErrorType<void>,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof pakkettenAll>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getPakkettenAllQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 *  <br /> Required permissions:<br /> <ul> <li>Permission: Inregeling.InregelingAanpassen</li></ul>
 * @summary Voegt een nieuw pakket toe of wijzigt een bestaande.
 */
export const pakkettenPost = (
  productenPakkettenPakketDto?: MaybeRefOrGetter<ProductenPakkettenPakketDto>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  productenPakkettenPakketDto = toValue(productenPakkettenPakketDto);

  return customInstance<void>(
    {
      url: `/api/v1/pakketten`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json-patch+json' },
      data: productenPakkettenPakketDto,
      signal,
    },
    options,
  );
};

export const getPakkettenPostMutationOptions = <
  TError = ErrorType<
    | void
    | MicrosoftAspNetCoreMvcProblemDetails
    | MicrosoftAspNetCoreHttpHttpValidationProblemDetails
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof pakkettenPost>>,
    TError,
    PakkettenPostMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof pakkettenPost>>,
  TError,
  PakkettenPostMutationVariables,
  TContext
> => {
  const mutationKey = ['pakkettenPost'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof pakkettenPost>>,
    PakkettenPostMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return pakkettenPost(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PakkettenPostMutationResult = NonNullable<Awaited<ReturnType<typeof pakkettenPost>>>;
export type PakkettenPostMutationBody = ProductenPakkettenPakketDto | undefined;
export type PakkettenPostMutationError = ErrorType<
  void | MicrosoftAspNetCoreMvcProblemDetails | MicrosoftAspNetCoreHttpHttpValidationProblemDetails
>;
export type PakkettenPostMutationVariables = { data?: ProductenPakkettenPakketDto };

/**
 * @summary Voegt een nieuw pakket toe of wijzigt een bestaande.
 */
export const usePakkettenPost = <
  TError = ErrorType<
    | void
    | MicrosoftAspNetCoreMvcProblemDetails
    | MicrosoftAspNetCoreHttpHttpValidationProblemDetails
  >,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof pakkettenPost>>,
      TError,
      PakkettenPostMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<ReturnType<typeof pakkettenPost>>,
  TError,
  PakkettenPostMutationVariables,
  TContext
> => {
  return useMutation(getPakkettenPostMutationOptions(options), queryClient);
};
/**
 *  <br /> Required permissions:<br /> <ul> <li>Permission: Inregeling.InregelingInzien</li></ul>
 * @summary Haalt een pakket op, op basis van pakketId
 */
export const pakkettenGetByPakketId = (
  pakketId: MaybeRefOrGetter<string | undefined | null>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  pakketId = toValue(pakketId);

  return customInstance<Result1OfProductenPakkettenPakketDto>(
    { url: `/api/v1/pakketten/${pakketId}`, method: 'GET', signal },
    options,
  );
};

export const getPakkettenGetByPakketIdQueryKey = (
  pakketId: MaybeRefOrGetter<string | undefined | null>,
) => {
  return ['api', 'v1', 'pakketten', pakketId] as const;
};

export const getPakkettenGetByPakketIdQueryOptions = <
  TData = Awaited<ReturnType<typeof pakkettenGetByPakketId>>,
  TError = ErrorType<void>,
>(
  pakketId: MaybeRefOrGetter<string | undefined | null>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof pakkettenGetByPakketId>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getPakkettenGetByPakketIdQueryKey(pakketId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof pakkettenGetByPakketId>>> = ({ signal }) =>
    pakkettenGetByPakketId(pakketId, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: computed(() => toValue(pakketId) !== null && toValue(pakketId) !== undefined),
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof pakkettenGetByPakketId>>, TError, TData>;
};

export type PakkettenGetByPakketIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof pakkettenGetByPakketId>>
>;
export type PakkettenGetByPakketIdQueryError = ErrorType<void>;

/**
 * @summary Haalt een pakket op, op basis van pakketId
 */

export function usePakkettenGetByPakketId<
  TData = Awaited<ReturnType<typeof pakkettenGetByPakketId>>,
  TError = ErrorType<void>,
>(
  pakketId: MaybeRefOrGetter<string | undefined | null>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof pakkettenGetByPakketId>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getPakkettenGetByPakketIdQueryOptions(pakketId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 *  <br /> Required permissions:<br /> <ul> <li>Permission: Inregeling.InregelingAanpassen</li></ul>
 * @summary Verwijdert de gecachte geldige CCS-pakketconfiguraties.
 */
export const pakkettenVerversCcsPakketconfiguratieCache = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<void>(
    { url: `/api/v1/pakketten/ccs-pakketconfiguratie/cache/verversen`, method: 'POST', signal },
    options,
  );
};

export const getPakkettenVerversCcsPakketconfiguratieCacheMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof pakkettenVerversCcsPakketconfiguratieCache>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof pakkettenVerversCcsPakketconfiguratieCache>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ['pakkettenVerversCcsPakketconfiguratieCache'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof pakkettenVerversCcsPakketconfiguratieCache>>,
    void
  > = () => {
    return pakkettenVerversCcsPakketconfiguratieCache(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PakkettenVerversCcsPakketconfiguratieCacheMutationResult = NonNullable<
  Awaited<ReturnType<typeof pakkettenVerversCcsPakketconfiguratieCache>>
>;

export type PakkettenVerversCcsPakketconfiguratieCacheMutationError = ErrorType<void>;

/**
 * @summary Verwijdert de gecachte geldige CCS-pakketconfiguraties.
 */
export const usePakkettenVerversCcsPakketconfiguratieCache = <
  TError = ErrorType<void>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof pakkettenVerversCcsPakketconfiguratieCache>>,
      TError,
      void,
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<ReturnType<typeof pakkettenVerversCcsPakketconfiguratieCache>>,
  TError,
  void,
  TContext
> => {
  return useMutation(
    getPakkettenVerversCcsPakketconfiguratieCacheMutationOptions(options),
    queryClient,
  );
};
